import { render, staticRenderFns } from "./AnswerInviteProductiveUnitsTable.vue?vue&type=template&id=6537844b&scoped=true&"
import script from "./AnswerInviteProductiveUnitsTable.vue?vue&type=script&lang=js&"
export * from "./AnswerInviteProductiveUnitsTable.vue?vue&type=script&lang=js&"
import style0 from "./AnswerInviteProductiveUnitsTable.vue?vue&type=style&index=0&id=6537844b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6537844b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
